module.exports = __webpack_public_path__ + "static/media/couches-1.6b495615.jpg";